<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped lang="scss">
#app {
  min-height: 100vh;
}

</style>



// WEBPACK FOOTER //
// src/App.vue